import { render, staticRenderFns } from "./SalesFlyerViewPage.vue?vue&type=template&id=71c925a2"
import script from "./SalesFlyerViewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesFlyerViewPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SalesFlyerViewPage.vue?vue&type=style&index=0&id=71c925a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports